/* MMC holiday seasons - lightweight canvas particle layer (no libraries).
   Reads html[data-mmc-season]; reduced motion / Save-Data => no particles (CSS keeps the static tint).
   Add a season: add SEASONS.<key> = { desktop: n, mobile: n, make: fn, draw: fn, setup?: fn } */
(function () {
  if (window.__mmcSeasons) return; window.__mmcSeasons = true;
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var TAU = Math.PI * 2, R = Math.random;
  function rnd(a, b) { return a + R() * (b - a); }
  function pick(a) { return a[(R() * a.length) | 0]; }

  /* ---- shared drawers ---- */
  function glowDot(c, x, y, r, rgb, a) {
    var g = c.createRadialGradient(x, y, 0, x, y, r);
    g.addColorStop(0, 'rgba(' + rgb + ',' + a + ')'); g.addColorStop(.25, 'rgba(' + rgb + ',' + (a * .45) + ')'); g.addColorStop(1, 'rgba(' + rgb + ',0)');
    c.fillStyle = g; c.beginPath(); c.arc(x, y, r, 0, TAU); c.fill();
  }
  /* parallax-wrapped y so "nodes" drift with the page like the neuron tile (-scrollY/8) */
  function py(p, H) { var span = H + 120, y = (p.y - window.scrollY / 8) % span; return (y < 0 ? y + span : y) - 60; }

  function web(c, cx, cy, r, a0, a1, alpha) { /* corner spider web: radials + sagging rings */
    var spokes = 7, rings = 6, i, j, a, pts = [];
    c.strokeStyle = 'rgba(255,190,120,' + alpha + ')'; c.lineWidth = 1; c.shadowColor = 'rgba(255,140,40,.55)'; c.shadowBlur = 6;
    for (i = 0; i <= spokes; i++) { a = a0 + (a1 - a0) * i / spokes; pts.push(a); c.beginPath(); c.moveTo(cx, cy); c.lineTo(cx + Math.cos(a) * r, cy + Math.sin(a) * r); c.stroke(); }
    for (j = 1; j <= rings; j++) {
      var rr = r * j / rings; c.beginPath();
      for (i = 0; i < pts.length - 1; i++) {
        var ax = cx + Math.cos(pts[i]) * rr, ay = cy + Math.sin(pts[i]) * rr, bx = cx + Math.cos(pts[i + 1]) * rr, by = cy + Math.sin(pts[i + 1]) * rr;
        var mid = (pts[i] + pts[i + 1]) / 2, sag = rr * .86;
        if (i === 0) c.moveTo(ax, ay);
        c.quadraticCurveTo(cx + Math.cos(mid) * sag, cy + Math.sin(mid) * sag, bx, by);
      }
      c.stroke();
    }
    c.shadowBlur = 0;
  }
  function bat(c, x, y, s, flap) { /* silhouette with a faint ember rim so it reads on dark smoke */
    var w = Math.sin(flap) * .6;
    c.save(); c.translate(x, y); c.scale(s, s);
    c.shadowColor = 'rgba(255,120,30,.55)'; c.shadowBlur = 8; c.fillStyle = 'rgba(10,6,14,.92)';
    c.beginPath(); c.moveTo(0, -2);
    c.quadraticCurveTo(-6, -6 - w * 10, -14, -4 - w * 14); c.quadraticCurveTo(-11, -1, -12, 3 - w * 4); c.quadraticCurveTo(-8, 0, -6, 4); c.quadraticCurveTo(-3, 1, 0, 5);
    c.quadraticCurveTo(3, 1, 6, 4); c.quadraticCurveTo(8, 0, 12, 3 - w * 4); c.quadraticCurveTo(11, -1, 14, -4 - w * 14); c.quadraticCurveTo(6, -6 - w * 10, 0, -2);
    c.fill(); c.beginPath(); c.moveTo(-2, -3); c.lineTo(-1.6, -6); c.lineTo(-.6, -3.6); c.lineTo(.6, -3.6); c.lineTo(1.6, -6); c.lineTo(2, -3); c.fill();
    c.restore(); c.shadowBlur = 0;
  }
  function leaf(c, p) { /* simple maple-ish leaf */
    c.save(); c.translate(p.x, p.y); c.rotate(p.rot); c.scale(p.s, p.s * Math.abs(Math.cos(p.flip)) + .25 * p.s);
    c.fillStyle = 'rgba(' + p.col + ',' + p.a + ')'; c.shadowColor = 'rgba(' + p.col + ',.5)'; c.shadowBlur = 6;
    c.beginPath(); c.moveTo(0, -10);
    c.quadraticCurveTo(3, -6, 7, -7); c.quadraticCurveTo(5, -3, 9, 0); c.quadraticCurveTo(4, 1, 5, 5); c.quadraticCurveTo(2, 3, 0, 6);
    c.quadraticCurveTo(-2, 3, -5, 5); c.quadraticCurveTo(-4, 1, -9, 0); c.quadraticCurveTo(-5, -3, -7, -7); c.quadraticCurveTo(-3, -6, 0, -10); c.fill();
    c.shadowBlur = 0; c.strokeStyle = 'rgba(60,25,8,.35)'; c.lineWidth = .8; c.beginPath(); c.moveTo(0, -8); c.lineTo(0, 10); c.stroke();
    c.restore();
  }

  var SEASONS = {
    halloween: {
      desktop: 16, mobile: 8, /* jack-o'-lantern glow nodes */
      make: function (W, H) { return { x: R() * W, y: R() * (H + 120), r: rnd(10, 22), ph: R() * TAU, sp: rnd(.6, 1.4), col: pick(['255,140,30', '255,110,20', '255,170,60', '150,255,90']) }; },
      setup: function (st, W, H, mobile) { st.bat = null; st.nextBat = performance.now() + rnd(900, 2200); st.mobile = mobile; },
      draw: function (c, st, W, H, t, dt) {
        var webR = Math.min(W, H) * (st.mobile ? .42 : .3);
        var top = st.mobile ? 96 : 64; web(c, 0, top, webR, 0, Math.PI / 2, .2); web(c, W, H, webR * .9, Math.PI, Math.PI * 1.5, .16);
        for (var i = 0; i < st.ps.length; i++) {
          var p = st.ps[i], fl = .55 + .3 * Math.sin(t / 1000 * p.sp + p.ph) + .15 * Math.sin(t / 137 + p.ph * 3);
          glowDot(c, p.x, py(p, H), p.r, p.col, .38 * fl);
        }
        if (!st.bat && t > st.nextBat) { var dir = R() < .5 ? 1 : -1; st.bat = { x: dir > 0 ? -40 : W + 40, y: rnd(H * .18, H * .6), dir: dir, v: rnd(110, 160), s: rnd(1.6, 2.4) * (st.mobile ? .8 : 1), f: 0, wob: R() * TAU }; }
        if (st.bat) {
          var b = st.bat; b.x += b.dir * b.v * dt; b.f += dt * 14; b.wob += dt * 2;
          bat(c, b.x, b.y + Math.sin(b.wob) * 18, b.s, b.f);
          if (b.x < -60 || b.x > W + 60) { st.bat = null; st.nextBat = t + rnd(5000, 10000); }
        }
      }
    },
    thanksgiving: {
      desktop: 14, mobile: 7, /* falling leaves */
      make: function (W, H, init) { return { x: R() * W, y: init ? R() * H : -20, vy: rnd(18, 38), sw: rnd(14, 34), ph: R() * TAU, rot: R() * TAU, vr: rnd(-.8, .8), flip: R() * TAU, vf: rnd(.8, 1.8), s: rnd(1.1, 2.1), a: rnd(.5, .75), col: pick(['214,108,28', '176,62,24', '226,168,52', '160,92,30', '198,140,40']), x0: 0 }; },
      setup: function (st) { st.ps.forEach(function (p) { p.x0 = p.x; }); st.motes = []; for (var i = 0; i < (st.mobile ? 6 : 12); i++) st.motes.push({ x: R(), y: R() * 1.1, r: rnd(6, 14), ph: R() * TAU }); },
      draw: function (c, st, W, H, t, dt) {
        for (var m = 0; m < st.motes.length; m++) { var o = st.motes[m]; glowDot(c, o.x * W, py({ y: o.y * (H + 120) }, H), o.r, '255,190,90', .16 + .08 * Math.sin(t / 1300 + o.ph)); }
        for (var i = 0; i < st.ps.length; i++) {
          var p = st.ps[i]; p.y += p.vy * dt; p.ph += dt * .9; p.rot += p.vr * dt; p.flip += p.vf * dt; p.x = p.x0 + Math.sin(p.ph) * p.sw;
          if (p.y > H + 24) { var n = SEASONS.thanksgiving.make(W, H, false); n.x0 = n.x; st.ps[i] = n; continue; }
          leaf(c, p);
        }
      }
    },
    christmas: {
      desktop: 95, mobile: 45, /* snow (v2: a bit denser) */
      make: function (W, H, init) { var r = rnd(.8, 2.6); return { x: R() * W, y: init ? R() * H : -6, r: r, vy: 14 + r * 12, sw: rnd(8, 24), ph: R() * TAU, a: rnd(.35, .85), x0: 0 }; },
      setup: function (st, W, H, mobile) {
        st.ps.forEach(function (p) { p.x0 = p.x; });
        /* string-light "nodes": a few drooping strands of twinkling bulbs, parallaxed like the neuron net */
        st.strands = []; var n = mobile ? 3 : 4;
        for (var s = 0; s < n; s++) {
          var y0 = (s + .5) / n * (H + 120), bulbs = [], k = mobile ? 9 : 14, x1 = rnd(-.05, .15), x2 = rnd(.85, 1.05), sag = rnd(40, 90), tilt = rnd(-60, 60);
          for (var b = 0; b <= k; b++) { var u = b / k; bulbs.push({ u: u, x: x1 + (x2 - x1) * u, dy: tilt * (u - .5) + sag * 4 * u * (1 - u), col: ['230,40,50', '60,200,110', '255,205,90', '150,215,255'][b % 4], ph: R() * TAU, sp: rnd(.8, 2.2) }); }
          st.strands.push({ y: y0, bulbs: bulbs });
        }
        /* v2: garland of lights swagged along the top edge, just under the header */
        var hd = document.querySelector('.shopify-section-group-header-group .navbar') || document.querySelector('.shopify-section-group-header-group');
        st.gTop = Math.max(0, Math.min(170, hd ? hd.getBoundingClientRect().bottom : 70));
        st.swags = mobile ? 4 : 7; st.garland = [];
        var per = 3, tot = st.swags * per;
        for (var g = 0; g <= tot; g++) st.garland.push({ u: g / tot, col: ['230,40,50', '255,205,90', '60,200,110', '150,215,255'][g % 4], ph: R() * TAU, sp: rnd(1, 2.4) });
      },
      draw: function (c, st, W, H, t, dt) {
        /* top garland (fixed to the viewport top, follows the sticky header) */
        var gy = st.gTop - 9, sw = W / st.swags, dep = st.mobile ? 8 : 10; /* hangs along the header's bottom edge, clear of the breadcrumb */
        c.strokeStyle = 'rgba(120,150,125,.4)'; c.lineWidth = 1.3; c.beginPath();
        for (var g = 0; g < st.swags; g++) { c.moveTo(g * sw, gy); c.quadraticCurveTo((g + .5) * sw, gy + dep * 2, (g + 1) * sw, gy); }
        c.stroke();
        for (g = 0; g < st.garland.length; g++) {
          var L = st.garland[g], gx = L.u * W, f = (L.u * st.swags) % 1, yy = gy + dep * 4 * f * (1 - f) + 4,
              chase = .5 + .5 * Math.sin(t / 420 - g * .9), tw = .35 + .65 * Math.max(chase, .6 * Math.max(0, Math.sin(t / 1000 * L.sp + L.ph)));
          glowDot(c, gx, yy, 15, L.col, .7 * tw);
          c.fillStyle = 'rgba(' + L.col + ',' + (.65 + .35 * tw) + ')'; c.beginPath(); c.ellipse(gx, yy, 2.4, 3.4, 0, 0, TAU); c.fill();
        }
        for (var s = 0; s < st.strands.length; s++) {
          var S = st.strands[s], y = py(S, H), bs = S.bulbs;
          c.strokeStyle = 'rgba(120,150,125,.32)'; c.lineWidth = 1.2; c.beginPath();
          for (var b = 0; b < bs.length; b++) { var X = bs[b].x * W, Y = y + bs[b].dy; if (b === 0) c.moveTo(X, Y); else c.lineTo(X, Y); }
          c.stroke();
          for (b = 0; b < bs.length; b++) {
            var q = bs[b], tw = .55 + .45 * Math.max(0, Math.sin(t / 1000 * q.sp + q.ph));
            glowDot(c, q.x * W, y + q.dy + 4, 26, q.col, .78 * tw);
            c.fillStyle = 'rgba(' + q.col + ',' + (.7 + .3 * tw) + ')'; c.beginPath(); c.ellipse(q.x * W, y + q.dy + 4, 2.7, 3.8, 0, 0, TAU); c.fill();
          }
        }
        c.fillStyle = '#fff';
        for (var i = 0; i < st.ps.length; i++) {
          var p = st.ps[i]; p.y += p.vy * dt; p.ph += dt * .6; p.x = p.x0 + Math.sin(p.ph) * p.sw;
          if (p.y > H + 8) { var n = SEASONS.christmas.make(W, H, false); n.x0 = n.x; st.ps[i] = n; continue; }
          c.globalAlpha = p.a; c.beginPath(); c.arc(p.x, p.y, p.r, 0, TAU); c.fill();
        }
        c.globalAlpha = 1;
      }
    }
  };
  window.MMCSeasons = SEASONS;

  function init() {
    var key = root.getAttribute('data-mmc-season'), cfg = key && SEASONS[key];
    if (!cfg) return;
    if (reduce.matches || saveData) { root.classList.add('mmc-season-static'); return; }
    var host = document.querySelector('.mmc-nbg--page'); if (!host) return;
    var cv = document.createElement('canvas'); cv.className = 'mmc-season-fx'; cv.setAttribute('aria-hidden', 'true');
    var shade = host.querySelector('.mmc-nbg__shade'); host.insertBefore(cv, shade || null);
    var c = cv.getContext('2d'), W = 0, H = 0, st = { ps: [] }, last = 0, raf = 0, running = false;
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5), w = window.innerWidth, h = window.innerHeight;
      if (Math.abs(w - W) < 2 && Math.abs(h - H) < 120 && st.ps.length) return; /* ignore mobile URL-bar resizes */
      W = w; H = h; cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); c.setTransform(dpr, 0, 0, dpr, 0, 0);
      var mobile = W < 750, n = mobile ? cfg.mobile : cfg.desktop; st = { ps: [], mobile: mobile };
      for (var i = 0; i < n; i++) st.ps.push(cfg.make(W, H, true));
      if (cfg.setup) cfg.setup(st, W, H, mobile);
    }
    function frame(t) {
      raf = 0; if (!running) return;
      var dt = Math.min(.05, last ? (t - last) / 1000 : .016); last = t;
      c.clearRect(0, 0, W, H); cfg.draw(c, st, W, H, t, dt);
      raf = requestAnimationFrame(frame);
    }
    function start() { if (running) return; running = true; last = 0; raf = requestAnimationFrame(frame); }
    function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
    size(); start();
    window.addEventListener('resize', size, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    if (reduce.addEventListener) reduce.addEventListener('change', function () { if (reduce.matches) { stop(); root.classList.add('mmc-season-static'); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
